"use strict";
/**
 * IconComponent
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var IconComponent = function (props) {
    return (react_1.default.createElement(material_1.IconButton, { style: { padding: '8px 8px' }, onClick: props.onClick, color: 'primary' }, props.icon));
};
exports.default = IconComponent;
